'use client';

import { SwdCircularProgress } from '@/components/swdCircularProgress/SwdCircularProgress';
import { useScrollLock } from '@/hooks/useScrollLock';
import classNames from 'classnames';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './LoadingBackdrop.module.scss';

const LoadingBackdrop: React.FC<{
  loading: boolean;
  text?: string;
  type?: 'page' | 'area' | 'card';
  className?: string;
}> = ({ loading, text, type = 'page', className }) => {
  const { t } = useTranslation();
  const scrollLock = useScrollLock();

  useEffect(() => {
    if (type === 'page') {
      if (loading) {
        scrollLock.lockScroll();
      } else {
        scrollLock.unlockScroll();
      }
    }
  }, [loading, type]);

  return (
    <>
      {loading && (
        <div
          className={classNames(classes.loadingBackdrop, className, {
            [classes.loadingBackdropAbsolute!]: type === 'area',
            [classes.loadingBackdropCard!]: type === 'card',
          })}
        >
          <SwdCircularProgress />
          <span className={classes.text}>{text ?? t('Daten werden geladen...')}</span>
        </div>
      )}
    </>
  );
};

export default LoadingBackdrop;
